// /src/store/mediaCategoryManagment/types.ts

import { MediaCategory } from '../../dataTypes/mediaManagment/types';

export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export interface MediaCategoryState {
  loading: boolean;
  categories: MediaCategory[];
  error: string | null;
  lastFetchTimestamp: number;
}

export const initialState: MediaCategoryState = {
  loading: false,
  categories: [],
  error: null,
  lastFetchTimestamp: 0,
};

export interface FetchCategoriesRequestAction {
  type: typeof FETCH_CATEGORIES_REQUEST;
}

export interface FetchCategoriesSuccessAction {
  type: typeof FETCH_CATEGORIES_SUCCESS;
  payload: {
    categories: MediaCategory[];
    lastFetchTimestamp: number;
  };
}

export interface FetchCategoriesFailureAction {
  type: typeof FETCH_CATEGORIES_FAILURE;
  payload: string;
}

export type MediaCategoryActionTypes =
  | FetchCategoriesRequestAction
  | FetchCategoriesSuccessAction
  | FetchCategoriesFailureAction;
